import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-out-buttons',
    imports: [CommonModule, TranslateModule],
    templateUrl: './out-buttons.component.html',
    styleUrl: './out-buttons.component.scss'
})
export class OutButtonsComponent implements OnInit {

  @Input() numOutputs: number = 1;
  @Input() slaves: any[] = []; // Array de esclavos XeoSwitch
  @Input() density: 'normal' | 'compact' = 'normal';
  @Output() outputChange = new EventEmitter<number>();
  selectedOutput: number = 1;

  get buttons(): number[] {
    // Outputs start at 1 for user display
    return Array(this.numOutputs).fill(0).map((_, i) => i + 1);
  }

  selectOutput(i: number) {
    this.selectedOutput = i;
    this.outputChange.emit(i);
  }

  // Obtiene el nombre del Xeoswitch para salidas > 4
  getXeoswitchName(outputNum: number): string {

    // Calcular qué esclavo corresponde a esta salida
    // output 5 = slave[0], output 6 = slave[1], etc.
    const slaveIndex = outputNum - 5;

    if (slaveIndex >= 0 && slaveIndex < this.slaves.length) {
      const slave = this.slaves[slaveIndex];
      // Usar 'name' si existe, si no usar el modelo
      return slave.name  || slave.model ;
    }

    return '';
  }

  constructor() { }

  ngOnInit(): void {
    if (this.numOutputs > 1) {
      this.selectedOutput = 1;
    }
  }
}
